import { Dispatch, SetStateAction } from "react";
import classNames from "classnames";
import { Button } from "components/atoms/Button";
import "./index.scss";

interface SelectedBtnState {
  [key: string]: boolean;
  "NotStarted": boolean;
  "InProgress": boolean;
  "Complete": boolean;
}

interface IProps {
  selectedBtn: SelectedBtnState;
  setSelectedBtn: Dispatch<SetStateAction<SelectedBtnState>>;
}

export const UpdateStatusDrillButtonSection = ({
  selectedBtn,
  setSelectedBtn,
}: IProps) => {
  const handleOnClick = (btnKey: string) => {
    setSelectedBtn({
      "NotStarted": false,
      "InProgress": false,
      "Complete": false,
    });
    setSelectedBtn((prevSelectedBtn: SelectedBtnState) => ({
      ...prevSelectedBtn,
      [btnKey]: true,
    }));
  };

  return (
    <div className={classNames("update-status-drill-button-section-wrapper")}>
      <div className={classNames("update-status-drill-button-section")}>
        <Button
          label="Not Started"
          type="filter"
          isSelected={selectedBtn["NotStarted"]}
          icon={false}
          onClick={() => handleOnClick("NotStarted")}
        />
        <Button
          label="In Progress"
          type="filter"
          isSelected={selectedBtn["InProgress"]}
          icon={false}
          onClick={() => handleOnClick("InProgress")}
        />
        <Button
          label="Complete"
          type="filter"
          isSelected={selectedBtn["Complete"]}
          icon={false}
          onClick={() => handleOnClick("Complete")}
        />
      </div>
    </div>
  );
};
